export const alphanumericOnly = /^[a-zA-Z0-9-]+$/;
export const simpleEmail = /^\S+@\S+$/;
export const zipcodeOnly = /^[0-9]{5}(?:-[0-9]{4})?$/;
export const yearOnly = /^[0-9]{4}$/;
export const usPhoneNumber = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
export const latitudeOnly = /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/;
export const longitudeOnly = /^[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/;
export const numberOnly = /[^0-9.-]/;
